import React from 'react';
import classNames from 'classnames';
import AuthorizationInput from '../../../components/input/AuthorizationInput';
import PERMISSION from '../../../constants/Permissions';
import GuaranteedBadge from './GuaranteedBadge';

const GuaranteedCheckbox = ({
	shift,
	slots,
	onGuaranteedCheckboxChange,
	isGuaranteed,
	className,
	preventGuaranteeOrBonusUpdates,
	isAllowedToToggle,
	hideLabelText
}) => (
	<div className={classNames(className)}>
		{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
		<label className={classNames('guaranteed-checkbox-label')}>
			<AuthorizationInput
				type="checkbox"
				disabled={!isAllowedToToggle || shift.is_orientation || preventGuaranteeOrBonusUpdates}
				checked={isGuaranteed}
				onChange={() => onGuaranteedCheckboxChange(slots)}
				exactPermission={PERMISSION.GUARANTEE}
				id={`guaranteed-toggle-${shift.id}`}
			/>

			<GuaranteedBadge hideLabelText={hideLabelText} isGuaranteed={isGuaranteed} />
		</label>
	</div>
);

export default GuaranteedCheckbox;
